interface ExtraDetailsProps {
    photographer: string
    sender: string
    mail: string
    phoneNumber: string
    validation: { mail: boolean, phoneNumber: boolean }
    onChange: (e: any) => void
    extraDetailsData: any
}

export class ExtraDetails extends React.Component<ExtraDetailsProps, State> {

    render() {
        const { photographer, sender, mail, phoneNumber, onChange, validation, extraDetailsData: { title, subTitle, mailPattern } } = this.props

        return (
            <div className="RedMailExtraDetails">
                {title && <div className="ExtraDetailsTitle">{title}</div>}
                {subTitle && <div className="ExtraDetailsSubTitle">{subTitle}</div>}

                <div className="inputFieldWrapper">
                    <div className="inputField">
                        <p className="title">קרדיט צלמ/ת</p>
                        <input name="photographer" dir="rtl" value={photographer} onChange={(e) => onChange(e)} type="text" id="photographer" placeholder="הזינו שם לקרדיט" ></input>
                    </div>

                    <div className="inputField">
                        <p className="title">שם השולח/ת</p>
                        <input name="sender" dir="rtl" value={sender} onChange={(e) => onChange(e)} type="text" id="sender" placeholder="הזינו שם פרטי ושם משפחה" ></input>
                    </div>

                    <div className="inputField">
                        <p className="title">כתובת מייל</p>
                        <input name="mail" dir="rtl" value={mail} onChange={(e) => onChange(e)} type="email" id="mail" placeholder="הזינו את האימייל שלכם" ></input>
                        {(mail && !validation.mail) && <p className="redMail-error-validation">{mailPattern}</p>}
                    </div>
                    
                    <div className="inputField">
                        <p className="title">מספר טלפון</p>
                        <input name="phoneNumber" dir="rtl" value={phoneNumber} onChange={(e) => onChange(e)} type="text" id="phoneNumber" placeholder="הזינו מספר" ></input>
                        {(phoneNumber && !validation.phoneNumber) && <p className="redMail-error-validation">המספר צריך להיות מורכב מ-10 ספרות ללא מקף</p>}
                    </div>
                </div>
            </div>
        )
    }
}